/**
 * HomePage - Main photo feed page
 */

import { useNavigate } from 'react-router-dom';
import { PhotoFeed } from '../components/feed/PhotoFeed';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';

export const HomePage = () => {
  const navigate = useNavigate();

  const handlePhotoClick = (photoId: string) => {
    navigate(`/photo/${photoId}`);
  };

  const handleUserClick = (userId: string) => {
    navigate(`/profile/${userId}`);
  };

  return (
    <div className="flex min-h-dvh flex-col bg-background">
      <Header />

      <main className="container mx-auto flex-1 px-4 py-6">
        <PhotoFeed onPhotoClick={handlePhotoClick} onUserClick={handleUserClick} />
      </main>

      <Footer />
    </div>
  );
};
